import {
  Component,
  NgModule,
  Input,
  ChangeDetectionStrategy,
  Output,
  EventEmitter,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { range } from 'rxjs';

@Component({
  selector: 'app-button-nav',
  templateUrl: 'button-nav.component.html',
  styleUrls: ['./button-nav.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ButtonNavComponent {
  @Input() pageCount = 0;
  @Input() currentPage = 0;
  @Output() pageChanged = new EventEmitter<number>();
  @Input() cancelAvailable = true;
  range = (i: number): number[] => [...Array(i).keys()].map((i) => i + 1);

  onClick(i: number) {
    // console.log(i);
    this.pageChanged.emit(i);
  }
}

@NgModule({
  imports: [CommonModule],
  declarations: [ButtonNavComponent],
  exports: [ButtonNavComponent],
})
export class ButtonNavModule {}
